import * as types from '../../action-types';
import {updateEducation as initialState } from "../../initialState";

const updateEducation = (state=initialState, action) => {
  switch (action.type) {
    case types.UPDATE_EDUCATION_START:
      return {
        ...state,
        isLoading: true
      };
    case types.UPDATE_EDUCATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.UPDATE_EDUCATION_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.UPDATE_EDUCATION_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default updateEducation;
